import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseGetInvalidateInfiniteQuery = (wrapperOptions) => {
    const useGetInvalidateInfiniteQuery = () => {
        const client = useQueryClient();
        return () => {
            const queryKey = getQueryBaseKey(wrapperOptions, 'infiniteQuery');
            return client.invalidateQueries({ queryKey });
        };
    };
    return useGetInvalidateInfiniteQuery;
};
